var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, reaction } from "mobx";
import { IAS_PATH, IAS_UPDATE_PATH } from "../UI/RoutingUIManager";
import { StudyVersionStatus } from "healthex-common/study.dtos";
export class FeatureManager {
    get features() {
        return this._features;
    }
    constructor(featureService, routingUIManager, studyService) {
        this.featureService = featureService;
        this.routingUIManager = routingUIManager;
        this.studyService = studyService;
        this._features = [];
        this.currentStudyId = undefined;
        reaction(() => this.routingUIManager.currentRoute, () => {
            var _a, _b, _c, _d;
            let studyId;
            if (((_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.studyId) === IAS_PATH ||
                ((_b = this.routingUIManager.currentRouteParams) === null || _b === void 0 ? void 0 : _b.studyId) === IAS_UPDATE_PATH) {
                studyId = null;
            }
            else {
                studyId = (_d = (_c = this.routingUIManager.currentRouteParams) === null || _c === void 0 ? void 0 : _c.studyId) !== null && _d !== void 0 ? _d : null;
            }
            if (studyId !== this.currentStudyId) {
                this.currentStudyId = studyId;
                void this.refreshFeatures();
            }
        }, { fireImmediately: true, name: "FeatureManager_currentRoute" });
    }
    isFeatureEnabled(featureFlag) {
        return this.features.some((f) => f.feature === featureFlag && f.enabled);
    }
    getFeatureConfiguration(featureFlag) {
        var _a, _b;
        return (_b = (_a = this.features.find((f) => f.feature === featureFlag)) === null || _a === void 0 ? void 0 : _a.configuration) !== null && _b !== void 0 ? _b : null;
    }
    decodeFeatureConfiguration(featureFlag) {
        var _a, _b;
        return (_b = (_a = this.features.find((f) => f.feature === featureFlag)) === null || _a === void 0 ? void 0 : _a.decodeConfiguration()) !== null && _b !== void 0 ? _b : null;
    }
    async refreshFeatures() {
        try {
            let organizationId;
            if (this.currentStudyId) {
                organizationId = await this.studyService
                    .getStudyPublicInfoById(this.currentStudyId, StudyVersionStatus.ACTIVE)
                    .then((study) => study === null || study === void 0 ? void 0 : study.addedByOrganization.id);
            }
            if (organizationId) {
                const features = await this.featureService.getFeaturesForOrganization(organizationId);
                this._features = features;
            }
            else {
                const features = await this.featureService.getGlobalFeatures();
                this._features = features;
            }
        }
        catch (error) {
            console.error("Error refreshing features", error);
            this._features = [];
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], FeatureManager.prototype, "_features", void 0);
